import React, { useCallback, useState } from "react";
import { Button, Input, Spinner } from "reactstrap";

import { useToast } from "../../hooks/toast";
import { AUTOPILOT_COLORS } from "../autopilot/styles";
import { acessoSftpAdminApi } from "./adminApi";

// "Gerar nova senha" (PO1-2166): confirmação inline em dois passos, como o Regenerar Token
// do EmbarcadorTokenModal. Aviso obrigatório: a senha atual para de funcionar na hora e a
// transportadora precisa atualizar a integração. Sem campo de senha: é sempre gerada pelo
// sistema. Vale para acesso novo em modo senha e para o legado (adoção no primeiro clique).
// `api` troca as rotas (admin × MeuFrete); `semEmail` esconde o campo de aviso (no MeuFrete
// quem gera é a própria transportadora). `onGerada(r)` recebe a resposta (a senha, quando vem).

const avisoStyle = {
  background: AUTOPILOT_COLORS.statusWarningBg,
  border: `1px solid ${AUTOPILOT_COLORS.statusWarningBorder}`,
  color: AUTOPILOT_COLORS.statusWarning,
  borderRadius: 6,
  padding: "0.75rem 1rem",
  marginTop: "0.6rem",
};
const EMAIL_RE = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

export default function GerarNovaSenha({ idEmbarcador, idTransportadora, emailSugerido, legado, onChanged, onGerada, api, semEmail, texto }) {
  const cliente = api || acessoSftpAdminApi;
  const { addToast } = useToast();
  const [confirmando, setConfirmando] = useState(false);
  const [email, setEmail] = useState(emailSugerido || "");
  const [loading, setLoading] = useState(false);

  const gerar = useCallback(async () => {
    try {
      setLoading(true);
      const r = await cliente.gerarNovaSenha(idEmbarcador, idTransportadora, { email: semEmail ? undefined : email.trim() || undefined });
      addToast({
        place: "tr",
        type: "success",
        title: legado ? "Acesso adotado" : "Senha alterada",
        description: r && r.usuario ? `Senha nova gravada para ${r.usuario}. Veja em "Mostrar senha".` : 'Senha nova gravada. Veja em "Mostrar senha".',
      });
      setConfirmando(false);
      if (onGerada) onGerada(r);
      if (onChanged) onChanged();
    } catch (e) {
      addToast({ place: "tr", type: "danger", title: "Erro", description: cliente.mensagemErro(e, "Falha ao gerar a senha.") });
    } finally {
      setLoading(false);
    }
  }, [cliente, idEmbarcador, idTransportadora, email, semEmail, legado, addToast, onChanged, onGerada]);

  const emailOk = semEmail || !email.trim() || EMAIL_RE.test(email.trim());

  if (!confirmando) {
    return (
      <Button color="warning" outline size="sm" onClick={() => setConfirmando(true)} disabled={loading}>
        Gerar nova senha
      </Button>
    );
  }

  return (
    <div style={avisoStyle}>
      <div style={{ fontSize: "0.84rem", marginBottom: "0.6rem" }}>
        {texto
          ? texto
          : legado
          ? "Este usuário foi criado na console. Ao confirmar, o Hub passa a gerenciar o acesso e troca SÓ a senha (nome, pastas e permissões ficam iguais). "
          : ""}
        {texto ? " " : ""}
        A senha atual <strong>para de funcionar na hora</strong>. {semEmail ? "Atualize a sua integração com a senha nova." : "A transportadora precisa atualizar a integração dela com a senha nova."}
      </div>
      {!semEmail ? (
        <>
          <div style={{ fontSize: "0.76rem", color: AUTOPILOT_COLORS.text, marginBottom: "0.3rem" }}>E-mail de aviso (opcional; sem a senha)</div>
          <Input type="email" bsSize="sm" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ti@transportadora.com.br" style={{ marginBottom: "0.6rem" }} />
        </>
      ) : null}
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <Button color="warning" size="sm" onClick={gerar} disabled={loading || !emailOk}>
          {loading ? <Spinner size="sm" /> : "Confirmar e gerar"}
        </Button>
        <Button color="secondary" size="sm" onClick={() => setConfirmando(false)} disabled={loading}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
